import request from "@/utils/request";
import {getToken} from "@/utils/auth";

// 查询文章列表
export function getArticleList(params) {
  return request({
    url: "/admin/articles/list",
    method: "get",
    params: params
  });
}

// 查询文章详情
export function getArticleInfo(id) {
  return request({
    url: "/admin/articles/" + id,
    method: "get"
  });
}

//获取文章选项
export function getArticleOptions() {
  return request({
    url: "/admin/articles/options",
    method: "get"
  });
}

//保存文章
export function addArticle(data) {
  return request({
    url: "/admin/articles",
    method: "post",
    data: data
  });
}

//保存文章
export function updateArticle(data) {
  return request({
    url: "/admin/articles",
    method: "put",
    data: data
  });
}

//上传图片
export function uploadImg(data) {
  return request({
    url: "/admin/articles/images",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

//逻辑删除
export function moveToRecycle(data) {
  return request({
    url: "/admin/articles/recycle",
    method: "put",
    data: data
  });
}

//恢复文章
export function backFromRecycle(data) {
  return request({
    url: "/admin/articles/back",
    method: "put",
    data: data
  });
}

//物理删除文章
export function removeArticle(data) {
  return request({
    url: "/admin/articles",
    method: "delete",
    data: data
  });
}

//置顶/取消置顶
export function updateArticleTop(data) {
  return request({
    url: "/admin/articles/top",
    method: "put",
    data: data
  });
}
